import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dynamicUrl from '../../../helper/dynamicUrls';
import AnimatedModal from '../../../components/Modal/AnimatedModal';

const ClockInOut = () => {
  const [isClockedIn, setIsClockedIn] = useState(false);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [clockInTime, setClockInTime] = useState(null);
  const [schoolCoordinates, setSchoolCoordinates] = useState(null);
  const [userAddress, setUserAddress] = useState('');
  const [businessAddress, setBusinessAddress] = useState();
  const [geoLocationEnabled, setGeoLocationEnabled] = useState(null);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const timerRef = useRef(null);
  const school_id = sessionStorage.getItem('school_id');

  // Example business address
  // const business_address = {
  //   pincode: 560001,
  //   phone_no: 8891144678,
  //   contact_name: "Ankush S",
  //   address_line1: "Trinity, MG Road",
  //   address_line2: "Yellappa Chetty Layout, Sivanchetti Gardens",
  //   city: "Bengaluru"
  // };

  const GEOAPIFY_API_KEY = '03f0afa401c74700a0a2c002d35f57b3';
  // const addressString = `${business_address.address_line1}, ${business_address.address_line2}, ${business_address.city}, ${business_address.pincode}`;

  // Function to save attendance data to the database

  const getTodayDateString = () => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
  };

  const upsertTeacherAttendance = async (payload) => {
    try {
      console.log('Upsert Attendance Payload:', payload);
      const response = await axios.post(
        dynamicUrl.upsertTeacherAttendance,
        payload,
        {
          headers: { Authorization: sessionStorage.getItem('user_jwt') }
        }
      );
      return response.data; // Return the response
    } catch (error) {
      console.error("Failed to upsert attendance:", error);
      throw error; // Re-throw the error to be caught by the caller
    }
  };

  const fetchTeacherAttendance = async (teacher_id, date) => {
    try {
      const res = await axios.post(
        dynamicUrl.fetchTeacherAttendance,
        { id: teacher_id, date },
        {
          headers: { Authorization: sessionStorage.getItem('user_jwt') }
        }
      );
      console.log("Attendance Response:", res.data);
      if (res.data && res.data.data && !res.data.data.last_clock_out_time) {
        const clockInDate = new Date(res.data.data.last_clock_in_time);
        setClockInTime(clockInDate);
        setIsClockedIn(true);
        const secondsElapsed = Math.floor((new Date() - clockInDate) / 1000);
        setElapsedSeconds(secondsElapsed);
      }
      return res.data.data;
    } catch (error) {
      console.error("Failed to fetch attendance:", error);
      return null;
    }
  };



  // Fetch school details and geo_location_enabled
  const fetchIndividualSchoolDetails = () => {
    axios
      .post(
        dynamicUrl.fetchSchoolDetails,
        {
          data: {
            school_id: school_id,
          }
        },
        {
          headers: { Authorization: sessionStorage.getItem('user_jwt') }
        }
      )
      .then((response) => {
        const item = response.data.Items[0];
        // Set geoLocationEnabled from API
        setGeoLocationEnabled(item?.school_subscribtion_feature?.geo_location_enabled === "Yes");
        // Set business address from API for geocoding
        setBusinessAddress(item?.school_contact_info?.business_address);

        // Geocode the school address
        const addressString = `${item?.school_contact_info?.business_address?.address_line1}, ${item?.school_contact_info?.business_address?.address_line2}, ${item?.school_contact_info?.business_address?.city}, ${item?.school_contact_info?.business_address?.pincode}`;
        fetchCoordinates(addressString);
      })
      .catch(() => {
        setGeoLocationEnabled(false);
        alert("Failed to fetch school details.");
      });
  };

  // Geocode school address using Geoapify
  const fetchCoordinates = async (addressString) => {
    try {
      const response = await axios.get(
        `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(
          addressString
        )}&apiKey=${GEOAPIFY_API_KEY}`
      );
      const { lat, lon } = response.data.features[0].properties;
      setSchoolCoordinates({ latitude: lat, longitude: lon });
    } catch (error) {
      console.error('Geoapify geocoding failed:', error);
      alert("Failed to fetch school location.");
    }
  };

  useEffect(() => {
    if (isClockedIn) {
      timerRef.current = setInterval(() => {
        setElapsedSeconds((prev) => prev + 1);
      }, 1000);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [isClockedIn]);

  useEffect(() => {
    const savedClockInTime = localStorage.getItem('clockInTime');
    const savedIsClockedIn = localStorage.getItem('isClockedIn') === 'true';

    if (savedIsClockedIn && savedClockInTime) {
      const clockInDate = new Date(savedClockInTime);
      const now = new Date();
      const secondsElapsed = Math.floor((now - clockInDate) / 1000);
      setClockInTime(clockInDate);
      setElapsedSeconds(secondsElapsed);
      setIsClockedIn(true);
    }else{
      const teacher_id = sessionStorage.getItem('teacher_id');
      const date = getTodayDateString();
  
      fetchTeacherAttendance(teacher_id, date);
    }
    
    fetchIndividualSchoolDetails();
  }, []);

  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

//  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
//     const lat1_num = parseFloat(lat1);
//     const lon1_num = parseFloat(lon1);
//     const lat2_num = parseFloat(lat2);
//     const lon2_num = parseFloat(lon2);

//     if (isNaN(lat1_num) || isNaN(lon1_num) || isNaN(lat2_num) || isNaN(lon2_num)) {
//       console.error("Invalid coordinates provided for distance calculation.");
//       return Infinity; 
//     }

//     const toRad = (value) => (value * Math.PI) / 180;
//     const R = 6371; 
    
//     const dLat = toRad(lat2_num - lat1_num);
//     const dLon = toRad(lon2_num - lon1_num);

//     const a =
//       Math.sin(dLat / 2) ** 2 +
//       Math.cos(toRad(lat1_num)) * Math.cos(toRad(lat2_num)) *
//       Math.sin(dLon / 2) ** 2;
      
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    
//     return R * c; 
//   };
 
  const reverseGeocode = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://api.geoapify.com/v1/geocode/reverse?lat=${latitude}&lon=${longitude}&apiKey=${GEOAPIFY_API_KEY}`
      );
      return response.data.features[0].properties.formatted || "Unknown location";
    } catch (error) {
      console.error("Geoapify reverse geocoding failed:", error);
      return "Address not found";
    }
  };

  const handleClockIn = async () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    if (geoLocationEnabled && !schoolCoordinates) {
      alert("School location not available yet.");
      return;
    }

    const processClockIn = async (address) => {
        const now = new Date();
        setClockInTime(now);
        setElapsedSeconds(0);
        setIsClockedIn(true);
        setUserAddress(address);

        localStorage.setItem('clockInTime', now.toISOString());
        localStorage.setItem('isClockedIn', 'true');
        localStorage.setItem('clockInAddress', address);

        const payload = {
            id: sessionStorage.getItem('teacher_id'),
            date: getTodayDateString(),
            last_clock_in_time: now.toISOString(),
            last_clock_in_address: address
        };
        
        try {
            await upsertTeacherAttendance(payload);
        } catch (error) {
            alert("Failed to save clock-in data. Please try again.");
            // Revert UI changes if API call fails
            setIsClockedIn(false);
            setClockInTime(null);
            localStorage.removeItem('clockInTime');
            localStorage.removeItem('isClockedIn');
            localStorage.removeItem('clockInAddress');
        }
    };

    if (geoLocationEnabled) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const distance = getDistanceFromLatLonInKm(
            latitude,
            longitude,
            schoolCoordinates.latitude,
            schoolCoordinates.longitude
          );

          if (distance > 1) {
            alert("You are not within 1 km of the school. Clock In denied.");
            return;
          }

          const address = await reverseGeocode(latitude, longitude);
          processClockIn(address);
        },
        () => {
          alert("Location access denied. Please enable location.");
        }
      );
    } else {
      processClockIn('');
    }
  };

  const handleClockOutClick = () => {
    setIsConfirmModalVisible(true);
  };

  const confirmClockOut = async () => {
    setIsConfirmModalVisible(false); // Close modal

    if (!navigator.geolocation) {
      alert("Geolocation is not supported.");
      return;
    }

    const teacher_id = sessionStorage.getItem('teacher_id');
    const date = getTodayDateString();

    // Fetch today's attendance to get the most accurate clock-in time/address
    const attendanceData = await fetchTeacherAttendance(teacher_id, date);
    
    let last_clock_in_time = (attendanceData && attendanceData.last_clock_in_time) || localStorage.getItem('clockInTime');
    let last_clock_in_address = (attendanceData && attendanceData.last_clock_in_address) || localStorage.getItem('clockInAddress');

    if (!last_clock_in_time) {
        alert("Could not determine clock-in time. Cannot clock out.");
        return;
    }

    const processClockOut = async (address) => {
        const clockOutTime = new Date().toISOString();
        
        let workingHours = null;
        if (last_clock_in_time) {
            const start = new Date(last_clock_in_time);
            const end = new Date(clockOutTime);
            const seconds = Math.floor((end - start) / 1000);
            workingHours = formatDuration(seconds);
        }

        const payload = {
            id: teacher_id,
            date,
            last_clock_in_time,
            last_clock_in_address,
            last_clock_out_time: clockOutTime,
            last_clock_out_address: address,
            working_hours: workingHours
        };

        try {
            await upsertTeacherAttendance(payload);

            setIsClockedIn(false);
            setElapsedSeconds(0);
            setClockInTime(null);
            setUserAddress('');
            clearInterval(timerRef.current);

            localStorage.removeItem('clockInTime');
            localStorage.removeItem('isClockedIn');
            localStorage.removeItem('clockInAddress');
            localStorage.removeItem('clockOutAddress');
        } catch (error) {
            alert("Failed to save clock-out data. Please try again.");
        }
    };

    if (geoLocationEnabled) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const address = await reverseGeocode(latitude, longitude);
          processClockOut(address);
        },
        () => {
          alert("Location access denied for clock-out.");
        }
      );
    } else {
      processClockOut('');
    }
  };

  const formatDuration = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  const formatDate = (date) =>
    date
      ? date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
      : '';

  return (
    <div className="container mt-4">
      <h5 className="fw-bold">Time & Attendance</h5>
      <div className="d-flex align-items-center justify-content-between mt-3">
        <div>
          <h1 className="text-primary fw-bold" style={{ fontSize: '3rem' }}>
            {formatDuration(elapsedSeconds)}
          </h1>
          <p className="text-muted mb-3">
            {formatDate(clockInTime || new Date())}
          </p>
          {!isClockedIn ? (
            <button className="btn btn-primary px-4 py-2 shadow" onClick={handleClockIn}>
              Clock In
            </button>
          ) : (
            <button className="btn btn-danger px-4 py-2 shadow" onClick={handleClockOutClick}>
              Clock Out
            </button>
          )}
        </div>

        <div>
          {userAddress && (
            <p className="text-muted mt-2">
              <strong>Location:</strong> {userAddress}
            </p>
          )}
        </div>

        <div
          className="bg-light text-center p-4 rounded"
          style={{ minWidth: '200px', backgroundColor: '#e9f4fd' }}
        >
          <h5 className="text-primary mb-2" style={{ fontSize: '1.25rem' }}>
            {clockInTime
              ? clockInTime.toLocaleTimeString('en-GB', { hour12: false })
              : '00:00:00'}
          </h5>
          <p className="fw-semibold mb-0">Clock In Time</p>
        </div>
      </div>
    
       <AnimatedModal
       visible={isConfirmModalVisible}
      onClose={() => setIsConfirmModalVisible(false)}
      animation="zoom"
     >
       <div className="card text-center" style={{ padding: '40px', borderRadius: '15px', boxShadow:
      '0 10px 30px rgba(0,0,0,0.1)', border: 'none' }}>
         <div className="card-body">
           {/* You can add an icon here, for example, a clock icon */}
           <h3 className="card-title" style={{ fontWeight: '600', marginBottom: '15px' }}>Are you
      sure?</h3>
          <p className="card-text text-muted" style={{ marginBottom: '30px' }}>
            You are about to clock out for the day. Your session will end.
          </p>
          <div className="d-flex justify-content-center mt-4">
           <button
             className="btn btn-light"
              onClick={() => setIsConfirmModalVisible(false)}
              style={{ padding: '10px 30px', marginRight: '20px', borderRadius: '8px', fontWeight:
      '600' }}
           >
              Cancel
           </button>
            <button
              className="btn btn-danger"
              onClick={confirmClockOut}
             style={{ padding: '10px 30px', borderRadius: '8px', fontWeight: '600' }}
           >
             Clock Out
           </button>
          </div>
        </div>
      </div>
    </AnimatedModal>
    </div>
  );
};

export default ClockInOut;